import React, { useEffect } from "react";

const Complete = () => {

  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = "https://www.gappeo.ai/";
    }, 5000);

    return () => clearTimeout(timer);
  }, [])

  return (
    <div className="language-container">
      <div className="language-test-section d-flex">
        <div className="language-left-section" style={{width:'100%'}}>
          <img src="/images/gappeo-logo.svg" alt="" width={86} height={71} />
          <div className="question-text">
            <h2>🎉 Completed</h2>
            <p>Your exam session has been completed. Thanks — you'll be redirected shortly.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Complete;